import { useState, useCallback } from 'react';
import { NavigationProps } from '../types/navigation.types';

export const useNavigation = (): NavigationProps => {
  const [navigationOpen, setNavigationOpen] = useState(true);

  const handleNavigationChange = useCallback(({ detail }: { detail: { open: boolean } }) => {
    setNavigationOpen(detail.open);
  }, []);

  return {
    navigationOpen,
    setNavigationOpen: handleNavigationChange,
  };
};